import { BaseTable } from "./BaseTable";

export function VideosAllTable() {
	return <BaseTable />;
}
